import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import SectionBlock from './section-block'
import styles from './style.scss'
import TTBH_FAQ from './const'

const TTBFaq = ({ isAppWebView, t }) => (
  <div
    className={clsx('ttb-faq__wrapper', {
      'web-view': isAppWebView,
    })}
  >
    <style jsx>{styles}</style>
    <div className="ttb-faq__title">
      <span className={clsx('ttb-faq__title-text', Typo.h4)}>
        {hasLocizeTranslation(
          t,
          TTBH_FAQ.title.disabledKey,
          TTBH_FAQ.title.value,
        )}
      </span>
    </div>
    {TTBH_FAQ.sections.map((section) => (
      <SectionBlock sectionData={section} />
    ))}
  </div>
)

TTBFaq.defaultProps = {
  isAppWebView: false,
}

TTBFaq.propTypes = {
  isAppWebView: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

export default withI18next()(TTBFaq)
